import React, { Fragment, useMemo, useState } from 'react';
import Button from '@material-ui/core/Button';
import { MenuItem, Popover } from '@material-ui/core';
import useTranslation from 'Hooks/useTranslation';
import { useAuth } from '../Contexts/AuthProvider';
import EventEmitter from 'utils/EventEmitter';
import { useBoxes } from 'Contexts/BoxContext';
import MyIcons from 'assets/img/Icons/MyIcons';

const OptionsMenu = props => {

    const {
        onRefresh,
        onRefreshNew,
        refreshDisabled = false,
        onChangeJob,
        changeJobDisabled = false,
        onChangeUnit,
        changeUnitDisabled = false,
        onLoadTemplate,
        onSaveTemplate,
        allowManageTemplate,
        disableSaveTemplate,
        allowExportCsv = true,
        exportCsvDisabled = false,
        onExportCsv,
        allowAutoLubeReport = false,
        onGenerateAutoLubeReport,
        isCurrentJobSet,
        exportCsvLabel,
        // inline: no button and popover, only the items are rendered (mobile actions menu), onClose is called after select
        inline = false,
        onClose,
    } = props;


    const { currentUser } = useAuth();
    const isOneJobPassword = useMemo(() => (currentUser && currentUser.isOneJobPassword), [currentUser])
    const allowExport = useMemo(() => currentUser.canExportCsv() && allowExportCsv, [currentUser, allowExportCsv]);

    const translation = useTranslation();

    const [addItemMenuAnchorEl, onAddItemMenuAnchorElChange] = useState(null);

    const { setModalStep } = useBoxes();

    const closeAddItemMenu = () => {
        onAddItemMenuAnchorElChange(null);
        if (inline && onClose) onClose();
    };

    const handleRefreshClick = () => {
        if (onRefresh)
            onRefresh();
            EventEmitter.emit('refreshBtnEventLogger')
        closeAddItemMenu();
    };

    const handleRefreshClickNew = () => {
        if (onRefreshNew)
            onRefreshNew();
            EventEmitter.emit('refreshBtnEventLogger')
        closeAddItemMenu();
    };

    const handleChangeJobClick = () => {
        if (onChangeJob)
            onChangeJob();

        closeAddItemMenu();
    }

    const handleChangeUnitClick = () => {
        if (onChangeUnit)
            onChangeUnit();

        closeAddItemMenu();
    }

    const renderRefreshButton = () => {
        if (!onRefresh) return null;
        return (
            <MenuItem
                disabled={refreshDisabled}
                className="filterMenuItem"
                onClick={handleRefreshClick}
                id="optionsMenuBtn-refresh"
            >
                <span>{translation.refreshButtonLabel}</span>
            </MenuItem>
        );
    };

    const renderRefreshButtonNew = () => {
        if (!onRefreshNew) return null;
        return (
            <MenuItem
                disabled={refreshDisabled}
                className="filterMenuItem"
                onClick={handleRefreshClickNew}
                id="optionsMenuBtn-refreshNew"
            >
                <span>Refresh</span>
            </MenuItem>
        );
    };

    const renderChangeJobButton = () => {
        if (!onChangeJob) return null;
        if (isOneJobPassword) return null;
        return (
            <MenuItem
                disabled={changeJobDisabled || !isCurrentJobSet}
                className="filterMenuItem"
                onClick={handleChangeJobClick}
                id="optionsMenuBtn-changeJob"
            >
                {translation.changeJobLabel}
            </MenuItem>
        );
    };

    const renderChangeUnitButton = () => {
        if (!onChangeUnit) return null;
        return (
            <MenuItem
                disabled={changeUnitDisabled}
                className="filterMenuItem"
                onClick={handleChangeUnitClick}
                id="optionsMenuBtn-changeUnit"
            >
                {translation.changeUnitLabel}
            </MenuItem>
        );
    };

    const renderMenuItems = () => (
        <Fragment>
            <MenuItem
                className="filterMenuItem"
                onClick={() => {
                    onLoadTemplate();
                    closeAddItemMenu();
                }}
                id="optionsMenuBtn-loadTemplate"
            >
                {translation.dashboardLoadTemplateLabel}
            </MenuItem>
            {
                allowManageTemplate && (
                    <MenuItem
                        disabled={disableSaveTemplate}
                        className="filterMenuItem"
                        onClick={() => {
                            onSaveTemplate();
                            closeAddItemMenu();
                        }}
                        id="optionsMenuBtn-saveTemplate"
                    >
                        {translation.saveTemplateButtonLabel}
                    </MenuItem>
                )
            }
            {
                allowExport && (
                    <MenuItem
                        disabled={exportCsvDisabled}
                        className="filterMenuItem"
                        onClick={() => {
                            onExportCsv();
                            closeAddItemMenu();
                            setModalStep('jobOptionsCsv')
                        }}
                        id="optionsMenuBtn-exportCsv"
                    >
                        {exportCsvLabel}
                    </MenuItem>
                )
            }
            {
                allowAutoLubeReport && (
                    <MenuItem
                        className="filterMenuItem"
                        onClick={() => {
                            onGenerateAutoLubeReport();
                            closeAddItemMenu();
                        }}
                        id="optionsMenuBtn-generateAutoLubeReport"
                    >
                        Generate Auto Lube Report
                    </MenuItem>
                )
            }
            {/* {renderRefreshButton()} */}
            {renderRefreshButtonNew()}
            {renderChangeJobButton()}
            {renderChangeUnitButton()}
        </Fragment>
    );

    if (inline) {
        return renderMenuItems();
    }

    return (
        <Fragment>
            <Button
                variant="outlined"
                color="primary"
                startIcon={<MyIcons icon="settingsIcon" />}
                id="optionsMenuBtn"
                onClick={(e) => onAddItemMenuAnchorElChange(e.currentTarget)}>
                {translation.dashboardOptionsLabel}
            </Button>
            <Popover
                anchorEl={addItemMenuAnchorEl}
                keepMounted
                transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                disableScrollLock={true}
                open={Boolean(addItemMenuAnchorEl)}
                onClose={closeAddItemMenu}
            >
                {renderMenuItems()}
            </Popover>
        </Fragment>
    );
};

export default OptionsMenu;
